
import * as React from "react"
import { cn } from "@/lib/utils"

const SidebarFooter = ({ className, children, ...props }: React.HTMLAttributes<HTMLElement>) => {
  return (
    <div className={cn("flex items-center justify-between h-16 px-4 border-t", className)} {...props}>
      {children}
    </div>
  )
}
SidebarFooter.displayName = "SidebarFooter"

export { SidebarFooter }
